import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';

// Old UI components
import HomeOld from './components/home/Home';
import HeaderOld from './components/templates/Header';
import FooterOld from './components/templates/Footer';
import CampDetailOld from './components/camps/CampDetail';
import AboutUsOld from './components/about/AboutUs';
import PickupOld from './components/pickup/Pickup';
import ListCampOld from './components/listCamp/ListCamp';
import AdvertisingOld from './components/advertising/Advertising';
import PartnerOld from './components/partner/Partner';

// New UI components
import HomeNew from './components/home/HomeNew';
import HeaderNew from './components/templates/HeaderNew';
import FooterNew from './components/templates/FooterNew';
import CampDetailNew from './components/camps/campDetailNew';
import AboutUsNew from './components/about/AboutUsNew';
import PickupNew from './components/pickup/PickupNew';
import ListCampNew from './components/listCamp/ListCampNew';
import AdvertisingNew from './components/advertising/AdvertisingNew';
import PartnerNew from './components/partner/PartnerNew';

import Dashboard from './components/dashboard/Dashboard';
import ResetPassword from './components/auth/ResetPassword';
import Modals from './components/modals';
import Camps from './components/camps/Camps';
import SpecialDeals from './components/camps/SpecialDeals';
import TermsConditions from './components/static/TermsConditions';
import PrivacyPolicy from './components/static/PrivacyPolicy';
import ScrollToTop from './components/static/ScrollToTop';
import Profile from './components/profile/Profile';
import Feeds from './components/feed/Feeds';
import Favorites from './components/favorites/Favorites';
import NotFoundPage from './components/NotFoundPage';
import { MainLoader } from './components/reuse/SVG';
import { mainLoaderAction, checkIsTeamsEZAction } from './store/ui';
import NonUser from './components/pickup/NonUser';
import Career from './components/careers/Career'
import NewsAndEvents from './components/newsAndEvent/NewsAndEvents'
import AutoScheduler from './components/autoscheduler/AutoScheduler';
import Cart from './components/cart';
import ConfirmedCart from './components/cart/loginuserconfirmedlist';
import ConfirmDetails from './components/cart/confirmDetails';
import EventCalendar from './components/eventCalendar';
import PaymentConfirmation from './components/cart/PaymentConfirmation';
import SelectCampers from './components/cart/selectcampers';
import AddCamper from './components/cart/addcampers';
import GiftCards from './components/giftCards/GiftCards';
import BuyGiftCard from './components/giftCards/BuyGiftCard';
import ViewBooking from './components/booking/ViewBooking';
import RegistrationSucces from './components/cart/regisrationSuccess';
import SupportFAQs from './components/static/SupportFAQs';
import GetUserDetailsPosts from './components/feed/GetUserDetailsPosts';
import Inbox from './components/inbox/Inbox';
import DirectorCamp from './components/directorCamp/DirectorCamp';
import AssociatePrograms from './components/associatePrograms';
import Counselors from './components/counselor/Counselors';
import Activity from './components/activity/Activity';
import Bookings from './components/bookings/Bookings';
import BookingDetail from './components/bookings/BookingDetail';
import CamperDetailNew from './components/bookings/CamperDetail';
import CamperDetailOld from './components/bookings/CamperDetailOld';
import RegistrationsReport from './components/reports/RegistrationsReport';
import Donate from './components/donate/Donate';
import AddActivity from './components/activity/AddActivity';
import EditActivity from './components/activity/EditActivity';
import AddCounselor from './components/counselor/addCounselor';
import EditCounselor from './components/counselor/editCounselor';
import StaffFormBuilder from './components/counselor/formBuilder/StaffFormBuilder';
import FolderDetails from './components/counselor/folderDetails';
import SelectActivity from './components/activity/SelectActivity';
import DirectorcampDetails from './components/directorCamp/DirectorcampDetails'
import FolderDetailsActivity from './components/activity/folderDetails'
import FolderDetailsBooking from './components/bookings/folderDetails'
import FolderDetailsBookingCamper from  './components/bookings/folderDetailscampers'
import Payments from  './components/profile/Payments'
import CabinOrganizer from './components/directorCamp/CabinOrganizer';
import NewsDetail from './components/newsAndEvent/NewsDetail';
import Welcome from './components/Welcome';
import Waiver1 from './components/static/Waiver1';
import Waiver2 from './components/static/Waiver2';
import Schedule from './components/counselor/Schedule';
import DistrictCamps from './components/camps/DistrictCamps';
import Users from './components/users/Users';
import UserDetail from './components/users/UserDetail';
import CreateBookingPage from './components/bookings/CreateBookingPage';
import OnlineStore from './components/online-store/OnlineStore';
import InboxPage from './components/inboxPage/InboxPage';
import AutomationAudits from './components/inboxPage/AutomationAudits';
import AutomationAuditRecipients from './components/inboxPage/AutomationAuditRecipients';
import SportsInternationalCamps from './components/camps/SportsInternationalCamps';
import SportInternationalCampDetail from './components/camps/SportInternationalCampDetail';
import ProductBookings from './components/product-bookings/ProductBookings';
import { getPageDataService } from './services/otherService';
import SiteDown from './components/SiteDown';
import AdminLogin from './components/auth/AdminLogin';
import SuperDirectorCampSelect from './components/auth/SuperDirectorCampSelect';
// Amplitude analytics disabled — see AmplitudeServiceInstance.init() below
// import AmplitudeServiceInstance from './config/Amplitude';
import { detectTrafficSource } from './helper';
import { AdditionalExperienceProvider } from "./context/AdditionalExperienceContext";
import { useAdditionalExperience } from "./context/AdditionalExperienceContext";
import AdditionalExperienceModal from "./components/bookings/BookingModals/ParentAdditionalExperienceModal";
import settings from './config/settings';

const USE_NEW_UI = settings.USE_NEW_UI;
const USE_NEW_STAFF_FORM = settings.USE_NEW_STAFF_FORM;

const Home        = USE_NEW_UI ? HomeNew        : HomeOld;
const Header      = USE_NEW_UI ? HeaderNew      : HeaderOld;
const Footer      = USE_NEW_UI ? FooterNew      : FooterOld;
const CampDetail  = USE_NEW_UI ? CampDetailNew  : CampDetailOld;
const AboutUs     = USE_NEW_UI ? AboutUsNew     : AboutUsOld;
const Pickup      = USE_NEW_UI ? PickupNew      : PickupOld;
const ListCamp    = USE_NEW_UI ? ListCampNew    : ListCampOld;
const Advertising = USE_NEW_UI ? AdvertisingNew : AdvertisingOld;
const Partner     = USE_NEW_UI ? PartnerNew     : PartnerOld;

const CamperDetail = settings.USE_NEW_BOOKING_PAGE ? CamperDetailNew : CamperDetailOld;

const PrivateRoute = ({ component: Component, loggedIn, ...rest }) => (
  <Route {...rest} render={(props) => (
    loggedIn ? <Component {...props} /> : <Redirect to='/' />
  )} />
)


export const scrollTop = () => window.onscroll = () => window.pageYOffset >= 40 ? document.body.classList.add('scroll_header') : document.body.classList.remove('scroll_header');

scrollTop();

const App = props => {

  const [UIData, setUIData] = useState({});

  const selectCSS = () => {
    let url = window.location.host;
    if (url.toLowerCase() === 'teamsez.com'){
      document.body.classList.add('teamsez_page');
      props.checkIsTeamsEZAction();
    }
  }
  const getPageData = () => {
    let query = `?page=maintenance`;
    getPageDataService(query).then(res => {
        if (res.data.statusCode){
          setUIData(res.data.responseData.result[0]);
        }
    })
  }

  useEffect(() => {
    getPageData();
    selectCSS();
    // Amplitude analytics disabled - init() is the only thing that starts the SDK,
    // so nothing is sent to api2.amplitude.com while this stays commented out.
    // AmplitudeServiceInstance.init();
  }, []);

useEffect(() => {
  const existingSource = localStorage.getItem('traffic_source');
  if (existingSource) return;

  const urlInfo = detectTrafficSource();
  if (!urlInfo) return;

  // Save if any tracking parameter is present
  if (urlInfo.src || urlInfo.sku || urlInfo._gl || urlInfo.adshopperClickId || urlInfo.utmSource) {
    const trafficSource = {
      landingPath: window.location.pathname,
      timestamp: new Date().toISOString()
    };

    if (urlInfo.src) {
      trafficSource.source = urlInfo.src;
    }

    if (urlInfo.sku) {
      trafficSource.sku = urlInfo.sku;
    }

    if (urlInfo._gl) {
      trafficSource._gl = urlInfo._gl;
    }

    // AdShopper tracking parameters
    if (urlInfo.adshopperClickId) {
      trafficSource.adshopperClickId = urlInfo.adshopperClickId;
    }

    if (urlInfo.utmSource) {
      trafficSource.utmSource = urlInfo.utmSource;
      trafficSource.isAdshopper = urlInfo.utmSource === 'adshopper'; // Flag for easy identification
    }

    if (urlInfo.utmMedium) {
      trafficSource.utmMedium = urlInfo.utmMedium;
    }

    if (urlInfo.utmCampaign) {
      trafficSource.utmCampaign = urlInfo.utmCampaign;
    }

    if (urlInfo.utmContent) {
      trafficSource.utmContent = urlInfo.utmContent;
    }

    if (urlInfo.utmTerm) {
      trafficSource.utmTerm = urlInfo.utmTerm;
    }

    localStorage.setItem(
      'traffic_source',
      JSON.stringify(trafficSource)
    );
  }
}, []);

  const isSuperDirectorCampSelect = !!(props.userProfile && Number(props.userProfile.UserType) === 11 && !props.userProfile.superDirectorCampSelected);

  return(
    <AdditionalExperienceProvider>
      <AdditionalExperienceModal />
      <div className="site_wrapper">
        <ScrollToTop />
        {props.mainLoader ? <MainLoader /> : ''}
        <Header  isMaintenance = {UIData?.isMaintenance} hideNav={isSuperDirectorCampSelect} />
        {UIData?.isMaintenance ?
          <SiteDown UIData={UIData}/>
          : isSuperDirectorCampSelect ?
          <SuperDirectorCampSelect />
          :
        <Switch>
          <Route exact path='/'                                                      {...props} component={ props.userProfile ? props.userProfile.UserType === 2 ? Dashboard : props.userProfile.UserType === 4 ?  Bookings : Home :Home } />
          <PrivateRoute path='/profile'                                              {...props} component={ Profile } />
          <Route exact path='/terms-and-conditions'                                  {...props} component={ TermsConditions } />
          <Route exact path='/privacy-policy'                                        {...props} component={ PrivacyPolicy } />
          <Route exact path='/camps'                                                 {...props} component={ Camps } />
          <Route exact path='/district-camps'                                        {...props} component={ DistrictCamps } />
          <Route exact path='/sports-international-camps'                            {...props} component={ SportsInternationalCamps } />
          <Route exact path='/camps/:id'                                             {...props} component={ CampDetail } />
          <Route exact path='/sports-international-camps/:spcampname'                {...props} component={ SportInternationalCampDetail } />
          <Route exact path='/special-offers'                                        {...props} component={ SpecialDeals } />
          <Route exact path='/about-us'                                              {...props} component={ AboutUs } />
          <Route exact path='/reset-password/:token'                                 {...props} component={ ResetPassword } />
          <Route exact path='/feeds'                                                 {...props} component={ Feeds } />
          <PrivateRoute exact path='/online-store'                                   {...props} component={ OnlineStore } />
          <PrivateRoute exact path='/online-store/:id'                               {...props} component={ OnlineStore } />
          <PrivateRoute exact path='/pickup'                                         {...props} component={ Pickup } />
          <PrivateRoute exact path='/pickup/add-non-user'                            {...props} component={ NonUser } />
          <PrivateRoute exact path='/favorite'                                       {...props} component={ Favorites } />
          <PrivateRoute exact path='/inbox'                                          {...props} component={ props.userProfile ? props?.userProfile?.UserType === 1 ? Inbox :  InboxPage : Home } />
          <PrivateRoute exact path='/inbox/automation-audit/:automationId'           {...props} component={ AutomationAudits } />
          <PrivateRoute exact path="/automation-audit/recipients/:executionId"       {...props} component={AutomationAuditRecipients} />
          <PrivateRoute exact path='/director-camps'                                 {...props} component={ DirectorCamp } />
          <PrivateRoute exact path='/cabin-organizer/:id'                            {...props} component={ CabinOrganizer } />
          <PrivateRoute exact path='/personnel'                                      {...props} component={ Counselors } />
          <PrivateRoute exact path='/personnel/schedule'                             {...props} component={ Schedule } />
          <PrivateRoute exact path='/my-calendar'                                    {...props} component={ Schedule } />
          <PrivateRoute exact path='/activity'                                       {...props} component={ Activity } />
          <PrivateRoute exact path='/activity/edit/:id'                              {...props} component={ EditActivity } />
          <PrivateRoute exact path='/activity/add'                                   {...props} component={ AddActivity } />
          <PrivateRoute exact path='/users'                                          {...props} component={ Users } />
          <PrivateRoute exact path='/users/detail/:id'                               {...props} component={ UserDetail } />
          <PrivateRoute exact path='/bookings'                                       {...props} component={ Bookings } />
          <PrivateRoute exact path='/bookings/:id'                                   {...props} component={ BookingDetail } />
          <PrivateRoute exact path='/bookings/:bookingId/:camperId/:programId'       {...props} component={ CamperDetail } />
          {settings.USE_REPORTING_TAB && <PrivateRoute exact path='/reports'           {...props} component={ RegistrationsReport } />}
          <PrivateRoute exact path='/booking/create'                                {...props} component={ CreateBookingPage } />
          <Route exact path='/career'                                                {...props} component={ Career } />
          <Route exact path='/list-camp'                                             {...props} component={ ListCamp } />
          <Route exact path='/advertising'                                           {...props} component={ Advertising } />
          <Route exact path='/partner'                                               {...props} component={ Partner } />
          <Route exact path='/news-and-events'                                       {...props} component={ NewsAndEvents } />
          <Route exact path='/news-and-events/:id'                                   {...props} component={ NewsDetail } />
          <PrivateRoute exact path='/calendar'                                       {...props} component={ EventCalendar } />
          <PrivateRoute exact path='/auto-scheduler'                                 {...props} component={ AutoScheduler } />
          <PrivateRoute exact path='/products-booking'                               {...props} component={ ProductBookings } />
          <Route exact path='/cart'                                                  {...props} component={ Cart } />
          <Route exact path='/cartconfirmed'                                         {...props} component={ ConfirmedCart } />
          <Route exact path='/payment-confirmation'                                  {...props} component={ PaymentConfirmation } />
          <Route exact path='/confirmdetails'                                        {...props} component={ ConfirmDetails } />
          <Route exact path='/selectcampers'                                         {...props} component={ SelectCampers } />
          <Route exact path='/addcampers'                                            {...props} component={ AddCamper } />
          <Route exact path='/registrationsuccess'                                   {...props} component={ RegistrationSucces } />
          <Route exact path='/gift-cards'                                            {...props} component={ GiftCards } />
          <Route exact path='/gift-cards/:id'                                        {...props} component={ BuyGiftCard } />
          <Route exact path='/faq'                                                   {...props} component={ SupportFAQs } />
          <Route exact path='/associateprograms'                                     {...props} component={ AssociatePrograms } />
          <Route exact path='/user/:id'                                              {...props} component={ GetUserDetailsPosts } />
          <Route exact path='/donate/:programId'                                     {...props} component={ Donate } />
          <Route exact path='/addcounselor'                                          {...props} component={ AddCounselor } />
          <Route exact path='/signup-staff/:id/:id2'                                 {...props} component={ AddCounselor } />
          {/* Form Builder only exists for the redesigned staff application — the legacy form has
              its fields hard-coded and ignores director-added questions entirely, so leaving this
              reachable would let a director configure questions that appear nowhere. */}
          {/* Directors only. PrivateRoute checks that someone is signed in, not who they are, and
              the builder's own mutations are gated server-side (autntctTknAdmnDir) — so without this
              a counselor reaching the URL directly gets a fully rendered form whose every button
              fails. The route stays registered and redirects rather than being omitted, so a
              non-director lands somewhere real instead of falling through to /404. */}
          {USE_NEW_STAFF_FORM ? <PrivateRoute exact path='/personnel/form-builder'  {...props} component={ props.userProfile?.UserType === 2 ? StaffFormBuilder : () => <Redirect to='/' /> } /> : ''}
          <Route exact path='/personnel/:id'                                         {...props} component={ EditCounselor } />
          <Route exact path='/personnel/folder/:id'                                  {...props} component={ FolderDetails } />
          <Route exact path='/director/camp/:id'                                     {...props} component={ DirectorcampDetails } />
          <Route exact path='/activity/:folderName'                                  {...props} component={ SelectActivity } />
          <Route exact path='/activity/folder/:id'                                   {...props} component={ FolderDetailsActivity } />
          <Route exact path='/payments'                                              {...props} component={ Payments } />
          <Route exact path='/bookings/folder/:id'                                   {...props} component={ FolderDetailsBooking } />
          <Route exact path='/camper/folder/:id'                                     {...props} component={ FolderDetailsBookingCamper } />
          <Route exact path='/waiver-1'                                              {...props} component={ Waiver1 } />
          <Route exact path='/waiver-2'                                              {...props} component={ Waiver2 } />
          <PrivateRoute exact path='/booking/:id/:programId'                         {...props} component={ ViewBooking } />
          <Route path="/404"                                                         {...props} component={ NotFoundPage } />
          <Route exact path='/sign-in/:userId/:isAdmin'                                             {...props} component={ AdminLogin } />
          <Welcome />
          <Redirect to="/404" />
        </Switch>
      }
        {!isSuperDirectorCampSelect && <Footer />}
        <Modals isMaintenance = {UIData?.isMaintenance}/>
      </div>
    </AdditionalExperienceProvider>
  )
}


const mapStateToProps = state => {
  let { mainLoader, isTeamsEZ } = state.ui;
  let { loggedIn, userProfile } = state.user;
  return {
    mainLoader,
    loggedIn,
    userProfile,
    isTeamsEZ
  }
}

const mapDispatchToProps = dispatch => ({
  mainLoaderAction: params => dispatch(mainLoaderAction(params)),
  checkIsTeamsEZAction: () => dispatch(checkIsTeamsEZAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
